const normalizeUid = (uid) => String(uid || "guest");

const storageKey = (prefix, uid) => `${prefix}_${normalizeUid(uid)}`;

const readValues = (storage, prefix, uid) => {
  try {
    const parsed = JSON.parse(storage.getItem(storageKey(prefix, uid)) || "[]");
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const createUidScopedState = (storage, prefix, uid) => ({
  uid: normalizeUid(uid),
  values: readValues(storage, prefix, uid),
});

export const getUidScopedValues = (currentState, uid) =>
  currentState.uid === normalizeUid(uid) ? currentState.values : [];

export const switchUidScopedState = (currentState, storage, prefix, uid) => {
  const nextUid = normalizeUid(uid);
  if (currentState.uid === nextUid) return currentState;
  return createUidScopedState(storage, prefix, nextUid);
};

export const addUidScopedValue = (
  currentState,
  storage,
  prefix,
  uid,
  value
) => {
  const scopedState = switchUidScopedState(currentState, storage, prefix, uid);
  if (scopedState.values.includes(value)) return scopedState;
  return { ...scopedState, values: [...scopedState.values, value] };
};

export const persistUidScopedState = (
  currentState,
  storage,
  prefix,
  uid
) => {
  const activeUid = normalizeUid(uid);
  if (currentState.uid !== activeUid) return false;
  storage.setItem(storageKey(prefix, activeUid), JSON.stringify(currentState.values));
  return true;
};
